import { useCallback, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { observer } from 'mobx-react';

import { DESKTOP_THRESHOLD } from '../../../config/constants';

import styles from './bingoFTUE.module.scss';
import { BingoFTUERive } from './BingoFTUERive';
import type { BingoFtueEntryPoint } from './BingoFTUERive';
import { useBingoFTUE } from './useBingoFTUE';

export interface BingoFTUEViewProps {
  entryPoint?: BingoFtueEntryPoint;
}

export const BingoFTUEView = observer(({ entryPoint = 'cc' }: BingoFTUEViewProps) => {
  const { terminateBingoFtueFlow, onBingoFtueEvent, showFtue, savedStep } = useBingoFTUE();

  const [isRiveReady, setIsRiveReady] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const prevShowFtueRef = useRef(showFtue);

  if (showFtue !== prevShowFtueRef.current) {
    prevShowFtueRef.current = showFtue;
    if (!showFtue) {
      setIsClosing(true);
    }
  }

  useEffect(() => {
    if (isClosing) {
      const timeout = setTimeout(() => setIsClosing(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [isClosing]);

  const handleRiveReady = useCallback(() => {
    setIsRiveReady(true);
  }, []);

  if (!showFtue && !isClosing) {
    return null;
  }

  const isDesktop = window.parent.innerWidth > DESKTOP_THRESHOLD;

  return (
    <div className={classNames(styles.overlay, { [styles.fadeOut]: !showFtue })}>
      <BingoFTUERive
        className={classNames({ [styles.riveReady]: isRiveReady })}
        entryPoint={entryPoint}
        savedStep={savedStep || null}
        terminateBingoFtueFlow={terminateBingoFtueFlow}
        viewType={isDesktop ? 'desktop' : 'mobile'}
        onBingoFtueEvent={onBingoFtueEvent}
        onRiveReady={handleRiveReady}
      />
    </div>
  );
});
